function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { rgba } from "../../../utils/styleUtils";
var useStyle = function(appearance, dismissible, hasCallToAction, isRtl) {
    var correctedAppearance = appearance === 'info' ? 'interactive' : appearance;
    var builtStyle = useBuildStyleWithTheme(function(theme, param) {
        var start = param.start, end = param.end, readingDirection = param.readingDirection;
        return buildStyle(theme, {
            appearance: correctedAppearance,
            start: start,
            end: end,
            readingDirection: readingDirection
        });
    }, {
        isRtl: isRtl
    });
    if (typeof builtStyle !== 'undefined') {
        var container = builtStyle.container, content = builtStyle.content, dismissButton = builtStyle.dismissButton, action = builtStyle.action, icon = builtStyle.icon, rest = _objectWithoutProperties(builtStyle, [
            "container",
            "content",
            "dismissButton",
            "action",
            "icon"
        ]);
        return _objectSpread({
            container: _objectSpread({}, container.base, appearance === 'warning' && container.warning),
            content: _objectSpread({}, content.base, appearance === 'warning' && content.warning),
            action: _objectSpread({}, action.base, {
                button: _objectSpread({}, action.button.base, appearance === 'warning' && action.button.warning)
            }, dismissible && action.dismissible),
            dismissButton: {
                buttonStyle: _objectSpread({}, dismissButton.base, appearance === 'warning' && dismissButton.warning, dismissButton.buttonStyle),
                iconStyle: _objectSpread({}, dismissButton.base, appearance === 'warning' && dismissButton.warning, dismissButton.iconStyle)
            },
            icon: _objectSpread({}, icon.base, appearance === 'warning' && icon.warning)
        }, rest);
    }
    return {
        container: {},
        dismissButton: {
            buttonStyle: {},
            iconStyle: {}
        },
        action: {},
        icon: {},
        content: {},
        iconContent: {},
        contentAction: {},
        dismiss: {}
    };
};
export { useStyle };
var buildStyle = function(theme, param) {
    var appearance = param.appearance, start = param.start, end = param.end, readingDirection = param.readingDirection;
    var _obj, _obj1;
    return {
        container: {
            base: _objectSpread({
                pointerEvents: 'auto',
                display: 'flex',
                backgroundColor: theme.backgroundColor[appearance].fill.base,
                lineHeight: theme.font.lineHeight.heading,
                borderColor: theme.borderColor[appearance].base,
                borderStyle: 'solid',
                borderWidth: theme.size.border.base,
                minHeight: 50,
                boxSizing: 'border-box',
                boxShadow: 'none',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                paddingLeft: theme.spacing[4],
                paddingRight: theme.spacing[4]
            }, readingDirection),
            warning: {
                backgroundColor: '#ffcc00'
            }
        },
        iconContent: _objectSpread({
            display: 'flex',
            flexWrap: 'nowrap'
        }, readingDirection),
        icon: {
            base: {
                alignSelf: 'flex-start',
                marginTop: theme.spacing[4],
                marginBottom: theme.spacing[4],
                height: 24,
                backgroundColor: theme.backgroundColor[appearance].fill.base,
                svg: {
                    fill: theme.backgroundColor[appearance].base
                }
            },
            warning: {
                backgroundColor: '#ffcc00',
                svg: {
                    fill: '#1a2026'
                }
            }
        },
        contentAction: _objectSpread({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 2
        }, readingDirection),
        content: {
            base: (_obj = {}, _defineProperty(_obj, start.margin, theme.spacing[4]), _defineProperty(_obj, end.margin, theme.spacing[5]), _defineProperty(_obj, "marginTop", theme.spacing[5]), _defineProperty(_obj, "marginBottom", theme.spacing[5]), _defineProperty(_obj, "backgroundColor", theme.backgroundColor[appearance].fill.base), _defineProperty(_obj, "color", theme.font.color[appearance].fill), _defineProperty(_obj, "fontFamily", theme.font.base.family), _defineProperty(_obj, "fontStyle", 'normal'), _defineProperty(_obj, "fontSize", theme.font.base.size.s), _defineProperty(_obj, "fontWeight", theme.font.base.weight.regular), _defineProperty(_obj, "letterSpacing", 'normal'), _defineProperty(_obj, "textIndent", 0), _defineProperty(_obj, "textShadow", 'none'), _defineProperty(_obj, "textTransform", 'none'), _obj),
            warning: {
                backgroundColor: '#ffcc00'
            }
        },
        action: {
            base: {
                marginTop: theme.spacing[3],
                marginBottom: theme.spacing[3]
            },
            button: {
                base: {
                    borderWidth: theme.size.border.base,
                    borderRadius: theme.size.border.radius.fiveX,
                    borderColor: theme.borderColor.neutral.fill.base,
                    borderStyle: 'solid',
                    backgroundColor: 'transparent',
                    color: theme.font.color.fill,
                    transitionProperty: 'box-shadow',
                    transitionDuration: theme.animation.duration[100],
                    transitionTimingFunction: theme.animation.productive.easeInOut.easing,
                    '&:hover': {
                        backgroundColor: rgba(theme.backgroundColor.neutral.fill.hover, theme.depth.opacity.light)
                    },
                    '&:active': {
                        backgroundColor: rgba(theme.backgroundColor.neutral.fill.active, theme.depth.opacity.heavy)
                    },
                    '&:focus-visible': {
                        outline: 0,
                        boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.neutral.fill.focus)
                    }
                },
                warning: {
                    borderColor: '#1a2026',
                    backgroundColor: 'transparent',
                    color: '#1a2026',
                    '&:hover': {
                        backgroundColor: '#8b6f00',
                        color: '#fff',
                        borderColor: '#836419'
                    },
                    '&:active': {
                        backgroundColor: '#665100',
                        color: '#fff'
                    },
                    '&:focus-visible': {
                        outline: 0,
                        boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px #1a2026")
                    }
                }
            },
            dismissible: _defineProperty({}, end.margin, 0)
        },
        dismiss: (_obj1 = {}, _defineProperty(_obj1, start.margin, theme.spacing[5]), _defineProperty(_obj1, "alignSelf", 'flex-start'), _defineProperty(_obj1, "marginTop", theme.spacing[3]), _defineProperty(_obj1, "marginBottom", 6), _defineProperty(_obj1, "height", 36), _defineProperty(_obj1, "cursor", 'pointer'), _obj1),
        dismissButton: {
            base: {
                borderRadius: theme.size.border.radius.round,
                borderWidth: 2,
                width: 36,
                height: 36,
                margin: 0,
                padding: 0,
                color: theme.font.color.fill,
                backgroundColor: 'transparent',
                transitionProperty: 'box-shadow',
                transitionDuration: theme.animation.duration[100],
                transitionTimingFunction: theme.animation.productive.easeInOut.easing,
                '&:hover': {
                    backgroundColor: rgba(theme.backgroundColor.neutral.fill.hover, theme.depth.opacity.light)
                },
                '&:active': {
                    backgroundColor: rgba(theme.backgroundColor.neutral.fill.active, theme.depth.opacity.heavy)
                },
                '&:focus-visible': {
                    outline: 0,
                    boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.neutral.fill.focus)
                }
            },
            warning: {
                backgroundColor: '#ffcc00',
                svg: {
                    fill: '#1a2026'
                },
                '&:hover': {
                    backgroundColor: '#8b6f00',
                    svg: {
                        fill: '#fff'
                    }
                },
                '&:active': {
                    backgroundColor: '#665100',
                    transform: theme.animation.transform.shrink,
                    svg: {
                        fill: '#fff'
                    }
                },
                '&:focus-visible': {
                    outline: 0,
                    boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px #1a2026")
                }
            },
            buttonStyle: {},
            iconStyle: {}
        }
    };
};
